import React, { ReactNode } from 'react';
import { Command } from 'cmdk';
import { TextField, Flex, Popover } from '@radix-ui/themes';

import './styles/multi-select.css';
import { useMultiSelect } from './multi-select.context';
import { observer } from 'mobx-react-lite';

type MultiSelectProps = Pick<
  React.ComponentProps<typeof Command>,
  'filter' | 'children' | 'shouldFilter'
> & {
  loading?: boolean;
};

export const MultiSelect = observer(
  ({ children, filter, shouldFilter, loading = false }: MultiSelectProps) => {
    const multiSelectCtx = useMultiSelect();
    return (
      <Flex className="autocomplete">
        <Popover.Root open={multiSelectCtx.opened} onOpenChange={multiSelectCtx.onOpenChange}>
          <Command
            className="autocomplete__cmdk"
            label="Command Menu"
            filter={filter}
            shouldFilter={shouldFilter}
          >
            <Command.Input asChild>
              <Popover.Trigger>
                <Flex wrap="wrap" gap="4">{multiSelectCtx.values.map((opt) => opt.viewValue)}

                  <TextField.Root
                    name={multiSelectCtx.name}
                    color="indigo"
                    size="3"
                    // value={autocompleteCtx.value}
                    // onChange={(e) => autocompleteCtx.onChange(e.target.value)}
                    // onBlur={() => {
                    //     if (!autocompleteCtx.value) {
                    //         autocompleteCtx.onSelect(autocompleteCtx.value);
                    //     }
                    // }}
                    onClick={multiSelectCtx.open}
                    onKeyDown={multiSelectCtx.open}
                  />
                </Flex>
                
              </Popover.Trigger>
            </Command.Input>

            <Popover.Content
              onOpenAutoFocus={(e) => {
                e.preventDefault();
              }}
              size="1"
              maxHeight="300px"
            >
              <Command.List className="autocomplete__list">
                {loading && <Command.Loading>Fetching words…</Command.Loading>}
                <Command.Empty>No results found.</Command.Empty>
                {children}
              </Command.List>
            </Popover.Content>
          </Command>
        </Popover.Root>
      </Flex>
    );
  }
);
